<div class="container overflow-auto mt-lg-3">
  <ul class="nav nav-secondary mixed-loyalty-nav">
    <a class="nav-item primary-theme py-2" [routerLink]="['/payment']" [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }">
      <label>{{ 'navbar.payment' | translate }}</label>
    </a>
    <a class="nav-item primary-theme py-2" [routerLink]="['/ecashhistory']" [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }">
      <label>{{ 'navbar.ecash.history' | translate }}</label>
    </a>
  </ul>
</div>